var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 45,
    viewBox: "0 0 253 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44H59.932C64.3503 44 67.932 40.4183 67.932 36V9C67.932 4.58172 71.5137 1 75.932 1H253",
    stroke: "#00FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep31);
export default __webpack_public_path__ + "static/media/step_3 (1).504fb331cbe360064715cc3c54021a00.svg";
export { ForwardRef as ReactComponent };